export default __webpack_public_path__ + "img/19cd1b13744488caf469d0cebd827acb.svg";